"use client";

import { Provider } from "react-redux";
import { Suspense } from "react";
import { store } from "@package/api/stores/store";
import ThemeRegistry from "./theme-registry";
import { SnackbarProviderWrapper } from "@package/components/StackAlerts/SnackbarProviderWrapper";
import { SnackbarListener } from "@package/components/StackAlerts/SnackbarListener";
import { LoadingProvider } from "@package/components/LoadingProvider";
import { GtmProvider } from "@package/util/context/GtmContext";
import MetaPixelEvents from "./MetaPixelEvents";
import GtmTracker from "./GtmTracker";

export default function Providers({ children, companyDetails = null }) {
  return (
    <Suspense fallback={null}>
      <Provider store={store}>
        <GtmProvider companyDetails={companyDetails}>
          <GtmTracker />
          <ThemeRegistry>
            <SnackbarProviderWrapper>
              <LoadingProvider>
                <SnackbarListener />
                <MetaPixelEvents />
                {children}
              </LoadingProvider>
            </SnackbarProviderWrapper>
          </ThemeRegistry>
        </GtmProvider>
      </Provider>
    </Suspense>
  );
}
